import { useAtomValue } from 'jotai';
import { AnimatePresence, motion, type MotionNodeAnimationOptions } from 'motion/react';

import { useRouteInfo } from '@/hooks/use-route-info';

import { Logo } from '@/components/logo';
import { StartingPointSelector } from '@/components/starting-point-selector';
import { AnimatedLoader } from '@flintmint/web-shared/components/animated-loader';

import { appReadyAtom, emptyAccountAtom, emptyLayoutAtom } from '@/state';

import styles from './empty-layout.module.scss';

const fadeCenter: MotionNodeAnimationOptions = {
  initial: { opacity: 0, scale: 0.985 },
  animate: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 0.985 },
  transition: { duration: 0.18, ease: 'easeOut' },
};

export const EmptyLayout = () => {
  const appReady = useAtomValue(appReadyAtom);
  const isEmptyLayout = useAtomValue(emptyLayoutAtom);
  const isEmptyAccount = useAtomValue(emptyAccountAtom);

  const { isLibrary } = useRouteInfo();

  const showStartingPoint = isLibrary && isEmptyAccount && appReady;

  // TODO if all routes have active document as param (not as search param) we could get rid of isEmptyLayoutAtom?
  return isEmptyLayout ? (
    <div className={styles.emptyLayout} data-testid="empty-layout">
      <AnimatePresence mode="wait" initial={false}>
        {showStartingPoint ? (
          <motion.div key="starting-point" {...fadeCenter}>
            <StartingPointSelector />
          </motion.div>
        ) : (
          <motion.div key="loading" {...fadeCenter}>
            <Logo appearance="greyscale" data-testid="logo" />
            <AnimatedLoader visible={!appReady} />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  ) : null;
};
